import { render, staticRenderFns } from "./RegionsDropdown.vue?vue&type=template&id=bf6d8dce"
import script from "./RegionsDropdown.vue?vue&type=script&lang=js"
export * from "./RegionsDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports